export const FETCH_ALL_PLANS_START = "FETCH_ALL_PLANS_START";
export const FETCH_ALL_PLANS_SUCCESS = "FETCH_ALL_PLANS_SUCCESS";
export const FETCH_ALL_PLANS_ERROR = "FETCH_ALL_PLANS_ERROR";
export const UPDATE_TAB_INDEX = "UPDATE_TAB_INDEX";

export const defaultPlansState = {
    tabIndex: "2", //pricing page top tab selector index to specify inbound / outbound / both
    inboundSlider: 0,
    outboundSlider: 0,
    plans: null,
    loading: false,
    errors: null,
};

export const plansContextReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_TAB_INDEX:
            return {
                ...state,
                tabIndex: payload,
            };
        case FETCH_ALL_PLANS_START: {
            return {
                ...state,
                loading: true,
            };
        }
        case FETCH_ALL_PLANS_SUCCESS: {
            return {
                ...state,
                loading: false,
                plans: payload,
            };
        }
        case FETCH_ALL_PLANS_ERROR: {
            return {
                ...state,
                loading: false,
                errors: payload,
            };
        }
        default:
            throw new Error();
    }
};
